import React, { FC } from 'react';
import { Box } from '@mui/material';
import ConnectedSupplierContact from './connected-supplier-contact/connected-supplier-contact.component';
import { LabClient } from 'models/client-directory';

type SupplierContactDetailsProps = {
    labClient: LabClient;
};
const SupplierContactDetails: FC<SupplierContactDetailsProps> = ({ labClient }: SupplierContactDetailsProps) => {
    return (
        <Box mt={3}>
            <ConnectedSupplierContact labClient={labClient} />
        </Box>
    );
};

export default SupplierContactDetails;
